
function setBillings(data) {
	return {
		type: "SET_BILLINGS",
		payload: data,
	};
}

export { setBillings };
